import { useCallback, useState, useEffect } from "react";
import {
  ChannelActionApi,
  ChannelEdit,
  createChannel,
  FetchChannelIdApi,
  UpdateStatusChannelApi,
  ViewChannel,
} from "../services/channelService";
import { validateRequired } from "../utils/validators";
import { useNavigate } from "react-router-dom";

export const useFetchChannel = (
  companyId,
  search,
  currentPage,
  perPage,
  status
) => {
  const [loading, setLoading] = useState(true);
  const [channel, setChannel] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const fetchChannel = useCallback(async () => {
    setLoading(true);
    try {
      const response = await ViewChannel(
        `&company_id=${companyId}&search=${search}&page=${currentPage}&page_count=${perPage}&active_status=${status}`
      );
      setChannel(response.get_channel_details);
      setTotalCount(response.page_context.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [companyId, search, currentPage, perPage, status]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchChannel();
    }, 500);

    return () => clearTimeout(timer);
  }, [fetchChannel]);

  return {
    loading,
    channel,
    refresh: fetchChannel,
    totalCount,
  };
};

// create Channel

export const useCreateChannel = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  const [formData, setFormData] = useState({
    channel_name: "",
    channel_topic: "",
    description: "",
    channel_people: [],
    company: "",
  });
  const validateStep = () => {
    const errors = {};
    const data = formData || {};
    if (!validateRequired(data.channel_name || "")) {
      errors.channel_name = "Channel name is required";
    }
    if (!validateRequired(data.channel_topic || "")) {
      errors.channel_topic = "Channel Topic is required";
    }
    // if (!validateRequired(data.description || "")) {
    //   errors.description = "Description is required";
    // }
    if (!validateRequired(data.company || "")) {
      errors.company = "Company is required";
    }
    if (formData.channel_people.length === 0) {
      errors.channel_people = "Staff are required";
    }
    setError(errors);
    return errors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError((prev) => {
      const updatedErrors = { ...prev };
      if (validateRequired(value)) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };
  const resetForm = () => {
    setFormData({
      channel_name: "",
      channel_topic: "",
      description: "",
      channel_people: [],
      company: "",
    });
    setSelectedCompanyId(null);
    setError({});
  };

  const handleSubmit = async () => {
    setLoading(true);
    const errors = validateStep();
    if (Object.keys(errors).length > 0) {
      setLoading(false);
      return;
    }

    try {
      await createChannel(formData);
      resetForm();
      navigate("/channel", { replace: true });
    } catch (error) {
      console.log(error.data);
      setError(error.data);
    } finally {
      setLoading(false);
    }
  };
  return {
    formData,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    setFormData,
    selectedCompanyId,
    setSelectedCompanyId,
    resetForm,
  };
};

//Fetch ChannelById
export const useFetchChannelByid = (id) => {
  const [loading, setLoading] = useState(true);
  const [channel, setChannel] = useState([]);
  const fetchChannel = useCallback(async () => {
    setLoading(true);
    try {
      const response = await FetchChannelIdApi(`?channel_id=${id}`);
      setChannel(response.selected_channel_details);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchChannel();
    }, 500);
    return () => clearTimeout(timer);
  }, [fetchChannel]);

  return {
    loading,
    channel,
    refresh: fetchChannel,
  };
};

//Edit channel

export const useEditChannel = (id) => {
  const [isLoading, setIsLoading] = useState(false);

  const editChannel = async (updates) => {
    setIsLoading(true);
    try {
      const response = await ChannelEdit(id, updates);
      return response;
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { editChannel, isLoading };
};

export const useEditChannelAction = (id) => {
  const [isLoading, setIsLoading] = useState(false);

  const editActionChannel = async (updates) => {
    setIsLoading(true);
    try {
      const response = await ChannelActionApi(id, updates);
      return response;
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { editActionChannel, isLoading };
};

//Deactive

export const useUpdateStatusChannel = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateChannelStatus = async (ids, statusType) => {
    setLoading(true);
    setError(null);
    const data = {
      channel_status: statusType,
      ids: ids,
    };

    try {
      await UpdateStatusChannelApi(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return { updateChannelStatus, loading, error };
};
